<script>
/* eslint-disable */
import ButtonIcon from "@/components/molecules/button-icon";
import { register } from "swiper/element/bundle";

register();

export default {
  name: "Carousel",
  components: { ButtonIcon },
  props: {
    elementsPerSlide: {
      type: [Number, String],
      required: false,
      default: 1
    },
    spaceBetween: {
      type: Number,
      required: false,
      default: 0
    },
    progressBar: {
      type: Boolean,
      required: false,
      default: false
    },
    navigationArrows: {
      type: Boolean,
      required: false,
      default: false
    },
    navigationIconColor: {
      type: String,
      required: false,
      default: "grey-3"
    },
    navigationIconColorHover: {
      type: String,
      required: false,
      default: "primary"
    },
    navigationIconSize: {
      type: String,
      required: false,
      default: "md"
    },
    navigationSize: {
      type: String,
      required: false,
      default: "md"
    },
    scrollBar: {
      type: Boolean,
      required: false,
      default: false
    },
    bullets: {
      type: Boolean,
      required: false,
      default: false
    },
    paginationPosition: {
      type: String,
      required: false,
      default: "center"
    },
    paginationSize: {
      type: String,
      required: false,
      default: "sm"
    },
    paginationBlock: {
      type: Boolean,
      required: false,
      default: false
    },
    freeMode: {
      type: Boolean,
      required: false,
      default: false
    },
    direction: {
      type: String,
      required: false,
      default: "horizontal"
    },
    thumbs: {
      type: Boolean,
      required: false,
      default: false
    },
    thumbsCarouselClass: {
      type: String,
      required: false,
      default: null
    },
    thumbsElementsPerSlide: {
      type: String,
      required: false,
      default: null
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: false
    },
    autoPlayDelay: {
      type: Number,
      required: false,
      default: 2500
    },
    loop: {
      type: Boolean,
      required: false,
      default: false
    },
    centerInsufficientSlides: {
      type: Boolean,
      required: false,
      default: false
    },
    watchOverflow: {
      type: Boolean,
      required: false,
      default: false
    },
    speed: {
      type: Number,
      required: false,
      default: 300
    },
    variant: {
      type: String,
      required: false
    },
    slidesOffsetBefore: {
      type: [String, Number],
      required: false,
      default: 0
    },
    slidesOffsetAfter: {
      type: [String, Number],
      required: false,
      default: 0
    },
    isGellule: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    cantDisplayAllFilter() {
      if (this.isGellule && this.isMounted) {
        return (
          this.$refs.swiperRef.swiper.el.scrollWidth >
          this.$refs.swiperRef.swiper.el.clientWidth
        );
      }
      return false;
    },
    paginationClass() {
      return [
        this.paginationPosition &&
          `c-carousel__pagination--${this.paginationPosition}`,
        this.paginationSize && `c-carousel__pagination--${this.paginationSize}`,
        this.paginationBlock && `c-carousel__pagination--block`
      ];
    },
    navigationClass() {
      return [
        this.navigationSize && `c-carousel__navigation--${this.navigationSize}`
      ];
    },
    displayArrow() {
      if (!this.isGellule) {
        return this.navigationArrows;
      }
      return this.cantDisplayAllFilter && !this.isEnded;
    },
    swiperOptions: (context) => {
      return {
        a11y: {
          prevSlideMessage: "Diapositive précédente",
          nextSlideMessage: "Diapositive suivante"
        },
        maxBackfaceHiddenSlides: 0,
        slidesPerView: context.elementsPerSlide,
        slidesOffsetBefore: context.slidesOffsetBefore,
        slidesOffsetAfter: context.slidesOffsetAfter,
        spaceBetween: context.spaceBetween,
        watchOverflow: context.watchOverflow,
        centerInsufficientSlides: context.centerInsufficientSlides,
        loop: context.loop,
        speed: context.speed,
        breakpoints: {
          0: {
            slidesPerGroup: 1
          }
        },
        pagination: context.progressBar
          ? {
              el: ".c-carousel__pagination",
              type: "progressbar"
            }
          : context.bullets
          ? {
              type: "bullets",
              el: ".c-carousel__pagination-bullets",
              clickable: true,
              bulletClass: "c-carousel__pagination-bullet",
              bulletActiveClass: "c-carousel__pagination-bullet--active"
            }
          : context.progressBar
          ? {
              el: ".c-carousel__pagination",
              type: "progressbar"
            }
          : false,
        navigation: context.navigationArrows
          ? {
              nextEl: ".c-carousel__navigation-next",
              prevEl: ".c-carousel__navigation-prev",
              disabledClass: "c-carousel__navigation--disabled",
              hiddenClass: "c-carousel__navigation--hidden"
            }
          : false,
        scrollbar: context.scrollBar
          ? {
              el: ".c-carousel__scrollbar",
              hide: false,
              draggable: true,
              dragClass: "c-carousel__scrollbar-drag",
              snapOnRelease: false
            }
          : false,
        thumbs: context.thumbs
          ? {
              swiper: {
                el: `.${context.thumbsCarouselClass}`,
                thumbsContainerClass: "c-carousel-thumbs",
                slideThumbActiveClass: "c-carousel-thumbs--active",
                slidesPerView: context.thumbsElementsPerSlide
              }
            }
          : false,
        freeMode: context.freeMode,
        direction: context.direction,
        autoplay: context.autoPlay
          ? {
              delay: context.autoPlayDelay,
              disableOnInteraction: false
            }
          : false,
        touchStartPreventDefault: false
      };
    }
  },
  methods: {
    next() {
      if (this.isGellule) {
        this.$refs.swiperRef.swiper.slideNext();
      }
      this.isEnded = this.$refs.swiperRef.swiper.isEnd;
    },
    previous() {
      if (this.isGellule) {
        this.$refs.swiperRef.swiper.slidePrev();
      }
      this.isEnded = this.$refs.swiperRef.swiper.isEnd;
    },
    stopAutoPlay() {
      if (this.autoPlay && this.$refs.swiperRef && this.playAutoPlay) {
        this.$refs.swiperRef.swiper.autoplay.stop();
      }
    },
    startAutoPlay() {
      if (this.autoPlay && this.$refs.swiperRef && this.playAutoPlay) {
        this.$refs.swiperRef.swiper.autoplay.start();
      }
    },
    update() {
      this.$refs.swiperRef.swiper.update();
    },
    toogleAutoPlay() {
      this.playAutoPlay = !this.playAutoPlay;
      if (this.playAutoPlay) {
        this.$refs.swiperRef.swiper.autoplay.start();
      } else {
        this.$refs.swiperRef.swiper.autoplay.stop();
      }
    },
    initialize() {
      const swiperEl = this.$refs.swiperRef;
      Object.assign(swiperEl, this.swiperOptions);
      swiperEl.initialize();
      this.$refs.swiperRef.swiper.on("slideChange", () => {
        if (this.$refs.swiperRef && this.$refs.swiperRef.swiper) {
          this.$emit("slideChange", this.$refs.swiperRef.swiper.realIndex);
        }
      });
      this.$refs.swiperRef.swiper.on("touchStart", () => {
        this.$emit("touchStart");
      });
    }
  },
  data() {
    return {
      playAutoPlay: true,
      isMounted: false,
      isEnded: false,
      index: 0
    };
  },
  emits: ["slideChange", "touchStart"],
  mounted() {
    this.initialize();
    this.isMounted = true;
  }
};
</script>

<template>
  <swiper-container
    class="swipper c-carousel"
    :class="variant && `c-carousel--${variant}`"
    role="region"
    aria-roledescription="Carrousel"
    ref="swiperRef"
    init="false"
    @mouseenter="stopAutoPlay"
    @mouseleave="startAutoPlay"
  >
    <slot class="swiper-wrapper c-carousel__wrapper" />

    <div slot="container-end">
      <div
        v-if="bullets || autoPlay"
        :class="paginationClass"
        class="c-carousel__pagination"
      >
        <div
          v-if="bullets"
          class="c-carousel__pagination-bullets"
        >
          <div class="swiper-pagination-bullet"></div>
        </div>

        <template v-if="autoPlay">
          <ButtonIcon
            v-if="playAutoPlay"
            :size="paginationSize === 'sm' ? 'xs' : paginationSize === 'lg' ? 'md' : 'sm'"
            :icon-size="paginationSize === 'sm' ? 'sm' : paginationSize === 'lg' ? 'lg' : 'md'"
            variant="white"
            radius="full"
            class="swiper-button-pause c-carousel__pause"
            icon-name="pause"
            icon-color="black"
            icon-color-hover="primary-light"
            icon-class=""
            @click="toogleAutoPlay()"
          />
          <ButtonIcon
            v-else
            :size="paginationSize === 'sm' ? 'xs' : paginationSize === 'lg' ? 'md' : 'sm'"
            :icon-size="paginationSize === 'sm' ? 'sm' : paginationSize === 'lg' ? 'lg' : 'md'"
            variant="white"
            radius="full"
            class="swiper-button-pause c-carousel__pause"
            icon-name="play"
            icon-color="black"
            icon-color-hover="primary-light"
            icon-class=""
            @click="toogleAutoPlay()"
          />
        </template>

      </div>

      <div
        v-if="navigationArrows"
        class="swiper-button-previous c-carousel__navigation c-carousel__navigation-prev"
        :class="navigationClass"
      >
        <ButtonIcon
          :icon-size="navigationIconSize"
          :class="navigationClass"
          :icon-name="direction == 'vertical' ? 'arrow-up' : 'arrow-left'"
          :icon-color="navigationIconColor"
          :icon-color-hover="navigationIconColorHover"
          icon-class="c-carousel__navigation-icon"
          @click="previous"
        />
      </div>
      <!-- 
      <ButtonIcon
        v-if="navigationArrows"
        class="swiper-button-previous  c-carousel__navigation c-carousel__navigation-prev"
        :icon-size="navigationIconSize"
        :class="navigationClass"
        :icon-name="direction == 'vertical' ? 'arrow-up' : 'arrow-left'"
        :icon-color="navigationIconColor"
        :icon-color-hover="navigationIconColorHover"
        icon-class="c-carousel__navigation-icon"
      /> -->

      <div
        v-if="displayArrow"
        class="swiper-button-coming c-carousel__navigation c-carousel__navigation-next"
        :class="navigationClass"
      >
        <ButtonIcon
          :icon-size="navigationIconSize"
          :class="navigationClass"
          :icon-name="direction == 'vertical' ? 'arrow-down' : 'arrow-right'"
          :icon-color="navigationIconColor"
          :icon-color-hover="navigationIconColorHover"
          icon-class="c-carousel__navigation-icon"
          @click="next"
        />
      </div>

      <div
        v-if="scrollBar"
        class="swiper-scrollbar c-carousel__scrollbar"
      />
    </div>
  </swiper-container>
</template>

<style lang="scss">
@import "@/assets/styles/components/carousel.scss";
</style>
